/** Generic top bar: logo/title text + optional right-aligned action buttons. */
export default function Header({ title, actions }) {
  return (
    <div class="etm-header">
      <div class="etm-logo">{title}</div>
      {actions ? <div class="etm-header-actions">{actions}</div> : null}
    </div>
  );
}
